import { Segmented } from '@vivaldis/antd-ui'
import {
  APP_BRANDS,
  APP_BRAND_NAMES,
  type AppBrand,
  useAppBrandState
} from '@vivaldis/common'

const options = [
  {
    label: APP_BRAND_NAMES[APP_BRANDS.VivaConnect],
    value: APP_BRANDS.VivaConnect
  },
  {
    label: APP_BRAND_NAMES[APP_BRANDS.BrickJobs],
    value: APP_BRANDS.BrickJobs
  }
]

export const AppBrandSwitch = () => {
  const { appBrand, setAppBrand } = useAppBrandState()

  return (
    <Segmented
      options={options}
      size="small"
      value={appBrand}
      onChange={value => setAppBrand(value as AppBrand)}
    />
  )
}
